import axios from 'axios';
import router from '../router';
import { useCookies } from "vue3-cookies";

const { cookies } = useCookies();

export default function setup() {

	axios.interceptors.response.use(null, error => {
		let path = '';
		//Agregar errores genéricos de la aplicacion
		console.log(error.response)
		switch (error.response.status) {
			case 401: if(error.response.config.url !== '/user/login'){
				path = { name: 'page-unauthorized' };
			}
			break;
			case 403: path = { name: 'page-forbidden' }; break;
		}
		if (path !== '') {
			router.push(path);
		}
		return Promise.reject(error);
	});

	axios.interceptors.request.use(function (config) {
		//Agregar Token autorizador
		if (config.url != '/user/refreshToken') {
			if (cookies.isKey('token')) {
				config.headers.Authorization = 'Bearer ' + cookies.get('token');
			} else if (cookies.isKey('refreshToken')) {
				axios.post('/user/refreshToken', { username: cookies.get('username'), userType: "BACKOFFICE", refreshToken: cookies.get('refreshToken') })
					.then((response) => {
						cookies.set('token', response.data.credentials.accessToken, response.data.credentials.expiresIn + 's');
						config.headers.Authorization = 'Bearer ' + cookies.get('token');
					})
					.catch(() => {
						router.push({ name: 'login' })
					});
			}
		}
		return config;
	}, function (err) {
		return Promise.reject(err);
	});
}

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;